"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function changeTab({ onTabChange, }) {
    return (state, actions, tabName) => {
        onTabChange(tabName);
        return Object.assign({}, state, { ui: Object.assign({}, state.ui, { currentTab: tabName }) });
    };
}
exports.changeTab = changeTab;
//# sourceMappingURL=change-tab.js.map